var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPhoto = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67234 19.9993H19.3277C21.1064 19.9993 22 19.1142 22 17.361V8.45038C22 6.69719 21.1064 5.8206 19.3277 5.8206H17.3447C16.6809 5.8206 16.4681 5.68442 16.0936 5.25889L15.4043 4.49294C14.9787 4.02485 14.5447 3.76953 13.6681 3.76953H10.2723C9.39574 3.76953 8.9617 4.02485 8.53617 4.49294L7.85532 5.25889C7.48085 5.67591 7.26809 5.8206 6.60426 5.8206H4.67234C2.89362 5.8206 2 6.69719 2 8.45038V17.361C2 19.1142 2.89362 19.9993 4.67234 19.9993ZM12 17.2759C9.42979 17.2759 7.3617 15.2078 7.3617 12.6206C7.3617 10.0334 9.42979 7.96528 12 7.96528C14.5787 7.96528 16.6468 10.0334 16.6468 12.6206C16.6468 15.2078 14.5787 17.2759 12 17.2759ZM18.1191 10.544C17.5404 10.544 17.0638 10.0759 17.0638 9.49719C17.0638 8.90996 17.5404 8.44187 18.1191 8.44187C18.6979 8.44187 19.1745 8.90996 19.1745 9.49719C19.1745 10.0759 18.6979 10.544 18.1191 10.544ZM12 15.9823C13.8553 15.9823 15.3617 14.4844 15.3617 12.6206C15.3617 10.7568 13.8553 9.25889 12 9.25889C10.1447 9.25889 8.64681 10.7568 8.64681 12.6206C8.64681 14.4844 10.1532 15.9823 12 15.9823Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPhoto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-photo.799a703c569f67685ecf5f8917860d7f.svg";